import { render, staticRenderFns } from "./CheckBoxAnswer.vue?vue&type=template&id=13107cb5&"
import script from "./CheckBoxAnswer.vue?vue&type=script&lang=js&"
export * from "./CheckBoxAnswer.vue?vue&type=script&lang=js&"
import style0 from "./CheckBoxAnswer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports